 const pathname = window.location.pathname.replace(/\/[^/]+$/, '')
 // const basePath = pathname + (pathname.substr(-1) !== '/' ? '/' : '/')
 const basePath = window.location.href
 const emptyPath = ''

 export const resources = {
  logo: `${emptyPath}images/logo.png`,
  facebook: `${emptyPath}images/facebook.png`,
  twitter: `${emptyPath}images/twitter.png`,
  youtube: `${emptyPath}images/youtube.png`,
}



// WEBPACK FOOTER //
// ./src/js/resources.js